import { mergeTemplate } from './base-template';

export const itTemplate = mergeTemplate({
  name: 'IT & Digital',
  icon: '💻',
  settings: {
    primaryColor: '#4f46e5',
    accentColor: '#06b6d4',
    darkMode: true,
    fontStack: 'instrument',
    stylePreset: 'glass',
    fxOrbs: true,
    fxGlass: true,
    fxIntensity: 'medium',
    pageAngebot: {
      heroTitle: 'IT-Dienstleistungen & Pakete',
      heroSubtitle: 'Digitale Lösungen, die funktionieren',
      packages: [
        { name: 'IT-Support', price: 'ab CHF 150/Mt.', description: 'Helpdesk und laufende Wartung', features: 'Remote-Support, Updates, Monitoring, Backup-Verwaltung, SLA', highlighted: false },
        { name: 'Entwicklung', price: 'ab CHF 160/h', description: 'Webentwicklung und Automatisierung', features: 'Frontend, Backend, API-Integration, Testing, Deployment', highlighted: true },
        { name: 'Cloud & Infrastruktur', price: 'auf Anfrage', description: 'Hosting, Migration und Skalierung', features: 'Cloud-Setup, Migration, Monitoring, Security, Performance-Optimierung', highlighted: false },
      ],
      ctaTitle: 'Digitalisierung beginnt mit einem Gespräch',
      ctaText: 'Lassen Sie uns Ihre IT-Herausforderungen besprechen — pragmatisch und lösungsorientiert.',
      ctaButtonText: 'Unverbindlich anfragen',
    },
    pageMethoden: {
      heroTitle: 'Unser Entwicklungsprozess',
      heroSubtitle: 'Agil, transparent, ergebnisorientiert',
      introText: 'Wir arbeiten iterativ und eng mit Ihnen zusammen — von der Idee bis zum Go-Live und darüber hinaus.',
      steps: [
        { title: 'Discovery', description: 'Anforderungsanalyse, Stakeholder-Interviews, technische Machbarkeit' },
        { title: 'Design', description: 'Architektur, Prototypen, UX/UI-Konzept, Techstack-Entscheid' },
        { title: 'Develop', description: 'Iterative Entwicklung in 2-Wochen-Sprints mit laufendem Feedback' },
        { title: 'Deploy & Improve', description: 'Go-Live, Monitoring, Optimierung, Support' },
      ],
      tools: [
        { name: 'GitHub', description: 'Versionskontrolle und Code-Review' },
        { name: 'Vercel / AWS', description: 'Cloud-Hosting und Deployment' },
        { name: 'Linear', description: 'Projektmanagement und Issue-Tracking' },
      ],
      philosophyTitle: 'Tech-Philosophie',
      philosophyText: 'Wir bauen keine Technik um der Technik willen. Jede Zeile Code muss einen Business-Wert haben.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Engineers mit Unternehmergeist',
      introText: 'Wir sind ein kleines, spezialisiertes Team mit Erfahrung in Start-ups, Agenturen und Konzernen.',
      timeline: [
        { year: '2016', text: 'Gründung als Web-Agentur' },
        { year: '2020', text: 'Fokus auf Cloud und Automatisierung' },
        { year: '2024', text: 'Expansion in AI-gestützte Lösungen' },
      ],
      values: [
        { title: 'Engineering Excellence', description: 'Sauberer Code, getestet, dokumentiert, wartbar' },
        { title: 'Pragmatismus', description: 'Die einfachste Lösung ist oft die beste' },
        { title: 'Ownership', description: 'Wir behandeln Ihr Projekt wie unser eigenes' },
      ],
      certifications: 'AWS Certified, Google Cloud Partner, ISO 27001 konform',
    },
  },
  components: {
    header: {
      companyName: 'Digital Muster',
      logoText: 'DM',
      navItems: ['Services', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Demo anfragen',
    },
    hero: {
      title: 'Build. Ship. Improve.',
      subtitle:
        'Web, Automation und Integrationen – sauber umgesetzt und messbar.',
      primaryBtn: 'Demo anfragen',
      secondaryBtn: 'Services',
    },
    trust: {
      items: [
        { value: 'API-first', label: 'Integration' },
        { value: 'Performance', label: 'Speed' },
        { value: 'Security', label: 'Basics' },
        { value: 'Delivery', label: 'Hands-on' },
      ],
    },
    services: {
      title: 'Services',
      subtitle: '',
      items: [
        {
          icon: '🧠',
          title: 'Automation',
          text: 'Workflows, Datenflüsse, AI-Assists – pragmatisch.',
        },
        {
          icon: '🧩',
          title: 'Integration',
          text: 'APIs, Tools, CRM – sauber verbunden.',
        },
        {
          icon: '🧱',
          title: 'Web',
          text: 'Landingpages, Websites, Portale – conversion-orientiert.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Engineers mit Unternehmergeist.',
      members: [
        {
          name: 'Marco Keller',
          role: 'Geschäftsführer & Lead Engineer',
          image: '',
          bio: 'Full-Stack-Entwicklung, Cloud-Architektur, Projektleitung.',
        },
        {
          name: 'Lena Hofmann',
          role: 'Frontend & UX',
          image: '',
          bio: 'React, TypeScript, Design-Systeme, Accessibility.',
        },
      ],
    },
    testimonials: {
      title: 'Feedback',
      items: [
        {
          quote: 'Schnell geliefert und sauber integriert.',
          author: 'Thomas Brunner',
          role: 'CEO, SaaS-Start-up Zürich',
        },
        {
          quote: 'Endlich eine IT-Firma, die versteht, was wir brauchen — nicht mehr und nicht weniger.',
          author: 'Sandra Meier',
          role: 'Geschäftsführerin, Handelsunternehmen',
        },
        {
          quote: 'Die API-Integration lief reibungslos. Sehr strukturierte Arbeitsweise.',
          author: 'Patrick Weber',
          role: 'CTO, FinTech AG',
        },
        {
          quote: 'Professioneller Support und schnelle Reaktionszeiten — genau was ein KMU braucht.',
          author: 'Andrea Schmid',
          role: 'Inhaberin, Beratungsfirma',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Wie startet ein Projekt?',
          answer:
            'Mit einem kostenlosen Discovery-Gespräch. Wir klären Ihre Anforderungen, definieren den Scope und erstellen einen klaren Umsetzungsplan — dann liefern wir iterativ.',
        },
        {
          question: 'Welche Technologien setzen Sie ein?',
          answer:
            'Wir arbeiten primär mit TypeScript, React, Node.js, Python und Cloud-Diensten (AWS, Vercel). Der Techstack wird je nach Projekt passend gewählt.',
        },
        {
          question: 'Bieten Sie auch laufenden Support an?',
          answer:
            'Ja. Neben Projektarbeit bieten wir SLA-basierte Support-Verträge ab CHF 150/Monat für Wartung, Monitoring und schnelle Hilfe bei Problemen.',
        },
      ],
    },
    cta: {
      title: 'Demo anfragen',
      subtitle:
        'Kurz schildern, wir schlagen die nächsten Schritte vor.',
      phone: '+41 00 000 00 00',
      email: 'hello@example.ch',
    },
    footer: {
      companyName: 'Digital Muster',
      tagline: 'Web & Automations in Ihrer Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'hello@example.ch',
    },
  },
});
